var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletAboutusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 219,
    viewBox: "0 0 194 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H194V207C194 213.627 188.627 219 182 219H12C5.37258 219 0 213.627 0 207V0Z",
    fill: "#3029D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.667 133.333C63.667 121.667 70.3337 116.667 80.3337 116.667H113.667C123.667 116.667 130.334 121.667 130.334 133.333V156.667C130.334 168.333 123.667 173.333 113.667 173.333H80.3337",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.666 135L103.233 143.333C99.7997 146.067 94.1663 146.067 90.733 143.333L80.333 135",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M63.667 160H83.667",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M63.667 146.667H73.667",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAboutusIcon);
export default __webpack_public_path__ + "static/media/WalletAboutusIcon.f60b2b319c6bfb157d1e73c572d0e42a.svg";
export { ForwardRef as ReactComponent };